import { BrokenImage } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

const InsuranceOption = ({ option, props }) => {
  return (
    <li {...props}>
      <Box sx={design.BoxInst}>
        <Box sx={design.BoxIMG}>
          {option.imagen === null ? (
            <BrokenImage sx={design.Broken} />
          ) : (
            <Box component="img" src={option.imagen} style={design.Img} />
          )}
        </Box>
        <Box flex={1}>
          <Typography fontWeight={700} fontSize={15}>
            {option.name}
          </Typography>
        </Box>
      </Box>
    </li>
  );
};

export default InsuranceOption;

const design = {
  BoxInst: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: 2,
    p: 1.5,
    borderRadius: 2,
    transition: "all .2s",
    "&:hover": {
      bgcolor: "#F5F8FF",
    },
  },
  BoxIMG: {
    width: 60,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 2,
    bgcolor: "#fff",
    border: "1px solid #E5E7EB",
    p: 0.5,
  },
  Img: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    // p:1
  },
  Broken: {
    color: "#BDBDBD",
    fontSize: 30,
  },
};
